import React from "react";
import { Container } from "react-bootstrap";
import Footer from "../../components/Footer/Footer";
import LoadProductPortfolios from "../../components/Portfolio/LoadProductPortfolios/LoadProductPortfolios";
import { StaticHero } from "../../components/StaticHero";

const ProductPortfolioPage = () => {
  const heroConf = {
    title: "Product Portfolios",
    subtitle:
      "Technowren is a company which provides prototyping, manufacturing, designing and fabrication of a mechanical/ electronics/ embedded system.",
  };
  return (
    <div>
      <StaticHero {...heroConf} />
      <Container>
        <LoadProductPortfolios />
      </Container>
      <br />
      <Footer />
    </div>
  );
};

export default ProductPortfolioPage;
